import { VisualBrick, registerBrick } from 'olympe';
import * as React from 'react';
import ReactDOM from 'react-dom';
import Alert from '@mui/material/Alert';
import InfoIcon from '@mui/icons-material/Info';
import AppsOutageIcon from '@mui/icons-material/AppsOutage';
import { RadioGroup, FormControlLabel, FormControl, FormLabel, Radio } from '@mui/material';

export default class OutageMessage extends VisualBrick {

    /**
       * This method runs when the brick is ready in the HTML DOM.
       * @override
       * @param {!BrickContext} context
       * @param {!Element} elementDom
       */
    draw(context, elementDom) {
        const message = context.getProperty('message')
        ReactDOM.render(<OutageMessage.Component
            message={message} />, elementDom);
        /* Write your code here. You have to implement this method ! */
    }
}

OutageMessage.Component = ({ message }) => {
    React.useEffect(() => {
        console.log("Outage message::")
    }, [])

    return (
        <>
            <FormControl component="fieldset">
                <Alert icon={<AppsOutageIcon fontSize="inherit" />}
                    severity='warning' sx={{
                        float: 'center', justifyContent: 'center',
                        maxWidth: '890px', width: '890px', fontSize: '1.25rem',
                        minHeight: '66px', padding: '0.2rem 0.5rem'    /* Scales with the font size */
                    }}>
                    {message.get()}
                </Alert>
            </FormControl>
        </>
    )
}

registerBrick('019eb18d0fa0559b0cda', OutageMessage);
